import { useContext } from 'react';
import { HCXFinancialCardListResizerContext } from './hcx-financial-card-list-resizer.context';

export const useHCXFinancialCardListResizerContext = () =>
  useContext(HCXFinancialCardListResizerContext);
